// Utility functions for handling video URLs from Firebase Storage

import { storage } from "../config/firebase";
import { ref, getDownloadURL } from "firebase/storage";

/**
 * Gets the Firebase Storage URL for the hero video
 * @returns Promise<string> The Firebase Storage download URL for the hero video
 */
export const getHeroVideoUrl = async (): Promise<string> => {
  try {
    const storageRef = ref(storage, "public/hero.mp4");
    const downloadURL = await getDownloadURL(storageRef);
    return downloadURL;
  } catch (error) {
    console.error("Error getting hero video URL from Firebase Storage:", error);
    // Fallback to empty string if video is not found in Firebase Storage
    // This allows the component to handle the missing video gracefully
    return "";
  }
};

/**
 * Gets the Firebase Storage URL for the hero video (synchronous version using environment variable)
 * This is useful when you have the URL stored in an environment variable or config
 * @returns string The hero video URL or empty string if not configured
 */
export const getHeroVideoUrlSync = (): string => {
  // Check if there's an environment variable for the hero video URL
  const envUrl = process.env.REACT_APP_HERO_VIDEO_URL;
  if (envUrl) {
    return envUrl;
  }
  
  // Fallback: construct Firebase Storage URL from storage bucket
  const storageBucket = process.env.REACT_APP_FIREBASE_STORAGE_BUCKET;
  if (storageBucket) {
    // Format: https://firebasestorage.googleapis.com/v0/b/BUCKET/o/FILENAME?alt=media
    // Note: Filename needs to be URL-encoded, especially for paths with slashes
    let bucketName = storageBucket;
    
    // Handle different bucket formats
    if (bucketName.includes(".appspot.com")) {
      bucketName = bucketName.replace(".appspot.com", "");
    } else if (bucketName.includes(".firebasestorage.app")) {
      bucketName = bucketName.replace(".firebasestorage.app", "");
    }
    
    const encodedPath = encodeURIComponent("public/hero.mp4");
    return `https://firebasestorage.googleapis.com/v0/b/${bucketName}/o/${encodedPath}?alt=media`;
  }
  
  return "";
};

